import { events, VIEW_ONLINE, ONLINE_VIEW } from './constants';
import type { GlobalAnalyticsEventDetails } from './types';
import type {
  AddToCartEvent,
  DocumentDownloadEvent,
  RemoveFromCartEvent,
  PageViewEvent,
} from './events';
import { convertProductsPriceToFloat } from './utils';

const addToCart = (param: AddToCartEvent): AddToCartEvent => {
  const { products, ...rest } = param;
  const newProducts = convertProductsPriceToFloat(products);
  return { products: newProducts, ...rest };
};

const removeFromCart = (param: RemoveFromCartEvent): RemoveFromCartEvent => {
  const { products, ...rest } = param;
  const newProducts = convertProductsPriceToFloat(products);
  return { products: newProducts, ...rest };
};

const download = (param: DocumentDownloadEvent): DocumentDownloadEvent => {
  const { documentReference, documentId, documentName, ...rest } = param;
  return {
    ...rest,
    documentId: documentId || documentReference,
    documentName:
      documentName === ONLINE_VIEW || documentName === VIEW_ONLINE ? VIEW_ONLINE : documentName,
    event: events.DOWNLOAD,
  };
};

const virtualPageview = (data: PageViewEvent): PageViewEvent => {
  const { page } = data;
  if (page) {
    return data;
  }
  const currentUrl = window.decodeURI(window.location.href);
  return { ...data, page: currentUrl };
};

export const postProcessing = (data: GlobalAnalyticsEventDetails): GlobalAnalyticsEventDetails => {
  switch (data.event) {
    case events.VIRTUAL_PAGE_VIEW:
      return virtualPageview(data);
    case events.ADD_TO_CART:
      return addToCart(data);
    case events.DOWNLOAD:
    case events.DOWNLOAD_DOCUMENT:
      return download(data);
    case events.REMOVE_FROM_CART:
      return removeFromCart(data);
    default:
      return data;
  }
};
